/* eslint-disable max-len */
import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const LineChartIcon: FC<IconProps> = props => {
  return (
    <BaseIcon {...props}>
      <path d="M4 5C4.55228 5 5 5.44772 5 6V17.4873L11.6504 11.6592C11.8558 11.4792 12.1145 11.3976 12.3672 11.4121C12.6176 11.4009 12.8728 11.4837 13.0752 11.6631L20.2988 18.0684L27.6846 11.6553C28.1015 11.2935 28.7326 11.3383 29.0947 11.7549C29.4569 12.1719 29.4131 12.8039 28.9961 13.166L21.0664 20.0518C20.9967 20.1123 20.9203 20.1603 20.8408 20.1982C20.4706 20.4566 19.9592 20.4397 19.6064 20.127L12.3564 13.6992L5.07031 20.085C5.04761 20.1049 5.02392 20.1231 5 20.1406V25H28C28.5523 25 29 25.4477 29 26C29 26.5523 28.5523 27 28 27H4C3.44772 27 3 26.5523 3 26V6C3 5.44772 3.44772 5 4 5Z" />
    </BaseIcon>
  );
};
